/**
 * Strength-meter color for a 0-100 score: red (weak) → amber (medium) →
 * green (strong). Used for the MBC brief completeness bars.
 */
export function scoreColor(value: number): string {
  if (value >= 80) return "#17B26A"; // green
  if (value >= 50) return "#F79009"; // amber

  return "#F04438"; // red
}
